export default __webpack_public_path__ + "static/Thomas_Janssen_2-cffbc93615a2f79e9f27f51e2acd9c2b.jpg";